import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
export function PricingWidget() {
  const CART_URL = 'https://pagos.avanzalab.online/checkouts/cn/hWN93DDL9U3kekOUwznOUDsA/es-ar?_r=AQABwkeeujeS07sT7Ib3di0hHptvQRbNe-xmvwPH9xudHaM&cart_link_id=bk0g09nZ&preview_theme_id=185849938234';
  return <section id="compra" className="w-full bg-black text-white py-16 px-4" aria-label="Precio y compra del Mega Pack" data-id="element-155">
      <div className="max-w-3xl mx-auto bg-[#111] border-2 border-amber-600 rounded-2xl p-6 md:p-10 shadow-2xl shadow-amber-900/20 relative overflow-hidden" data-id="element-156">
        <div className="text-center mb-8" data-id="element-157">
          <h2 className="text-gray-400 uppercase tracking-widest text-sm font-bold mb-4" data-id="element-158">
            Mega Pack Pisos Epoxi Pro Desde Cero
          </h2>

          <p className="text-lg md:text-xl font-bold text-amber-400 mb-4 max-w-lg mx-auto leading-tight" data-id="element-159">
            No necesitás 10 clientes. Con uno solo ya podés recuperar la
            inversión.
          </p>

          {/* Discount Badge */}
          <div className="inline-block bg-red-600 text-white px-4 py-1.5 rounded-full font-black text-sm md:text-base mb-4 animate-pulse shadow-lg shadow-red-600/30" role="status" aria-label="Descuento del 40 por ciento disponible hoy" data-id="element-160">
            🔥 40% OFF HOY
          </div>

          {/* Strikethrough old price */}
          <p className="text-2xl md:text-3xl text-gray-500 line-through font-bold mb-1" data-id="element-161">
            <span className="sr-only" data-id="element-162">Precio anterior: </span>$49.990
          </p>

          <p className="text-6xl md:text-7xl font-black text-white mb-2 tracking-tight" data-id="element-163">
            <span className="sr-only" data-id="element-164">Precio actual: </span>$29.990
          </p>
          <p className="text-gray-500 text-lg mb-6" data-id="element-165">ARS — pago único</p>

          <div className="inline-block bg-amber-900/30 text-amber-400 px-4 py-2 rounded-full font-bold border border-amber-700/40 text-sm" data-id="element-166">
            Acceso inmediato · Sin cuotas ocultas · Tuyo para siempre
          </div>

          {/* Trust info */}
          <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3" data-id="element-167">
            <div className="flex items-center justify-center gap-2 bg-[#1a1a1a] border border-gray-700 rounded-lg px-4 py-2 text-sm text-gray-300" data-id="element-168">
              <span aria-hidden="true" data-id="element-169">💳</span> Podés pagar en cuotas con
              tarjeta a través de MercadoPago.
            </div>
            <div className="flex items-center justify-center gap-2 bg-[#1a1a1a] border border-gray-700 rounded-lg px-4 py-2 text-sm text-gray-300" data-id="element-170">
              <span aria-hidden="true" data-id="element-171">⚡</span> Acceso automático inmediato
              después de la compra
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px w-full bg-amber-900/40 my-8" aria-hidden="true" data-id="element-172"></div>

        {/* Value reminder */}
        <div className="bg-[#1a1a1a] rounded-xl p-5 mb-8 text-left" data-id="element-173">
          <h3 className="text-white font-bold text-base mb-3" data-id="element-174">¿Qué incluye?</h3>
          <ul className="space-y-2 list-none p-0" data-id="element-175">
            {['5 tomos completos de formación técnica y comercial', 'Bono 1: Cómo crear tu pyme de pisos epoxi', 'Bono 2: Sistema para conseguir clientes todas las semanas', 'Bono 3: Mentalidad y posicionamiento de aplicador premium', 'Acceso ilimitado, sin vencimiento'].map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300 text-sm" data-id="element-176">
                <Check className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-177" />
                <span data-id="element-178">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* CTA Button */}
        <a href={CART_URL} className="w-full bg-amber-500 hover:bg-amber-400 text-black text-2xl md:text-3xl font-black py-6 px-4 rounded-xl shadow-[0_4px_0_rgb(146,100,10)] hover:shadow-[0_2px_0_rgb(146,100,10)] hover:translate-y-[2px] transition-all flex items-center justify-center gap-3 mb-3" aria-label="Quiero acceder ahora al Mega Pack por $29.990" data-id="element-179">
          QUIERO ACCEDER AHORA
          <ArrowRight className="w-6 h-6" aria-hidden="true" data-id="element-180" />
        </a>

        {/* Micro trust text */}
        <p className="text-center text-xs text-gray-600 mb-4" data-id="element-181">
          Acceso inmediato después del pago&nbsp;•&nbsp;Sin experiencia previa
          necesaria&nbsp;•&nbsp;Empezá hoy mismo
        </p>

        <ul className="flex justify-center items-center gap-4 text-gray-500 text-sm list-none p-0" data-id="element-182">
          <li className="flex items-center gap-1" data-id="element-183">
            <Check className="w-4 h-4" aria-hidden="true" data-id="element-184" /> Pago Seguro
          </li>
          <li className="flex items-center gap-1" data-id="element-185">
            <Check className="w-4 h-4" aria-hidden="true" data-id="element-186" /> Entrega Inmediata
          </li>
          <li className="flex items-center gap-1" data-id="element-187">
            <Check className="w-4 h-4" aria-hidden="true" data-id="element-188" /> Acceso de por vida
          </li>
        </ul>
      </div>
    </section>;
}